import { Check, X } from "lucide-react";

export const passwordRules = (password) => [
  { id: "len", label: "Mínimo de 8 caracteres", ok: password.length >= 8 },
  { id: "letter", label: "Pelo menos uma letra", ok: /[A-Za-z]/.test(password) },
  { id: "number", label: "Pelo menos um número", ok: /\d/.test(password) },
];

export const isStrongPassword = (password) => passwordRules(password).every((r) => r.ok);

export const PasswordStrength = ({ password }) => {
  const rules = passwordRules(password);
  const passed = rules.filter((r) => r.ok).length;
  const bonus = /[^A-Za-z0-9]/.test(password) && password.length >= 10 ? 1 : 0;
  const score = password ? Math.min(4, passed + bonus) : 0;
  const labels = ["", "Fraca", "Razoável", "Boa", "Forte"];
  const colors = ["bg-[#1A1A20]", "bg-[#E50914]", "bg-[#F97316]", "bg-[#EAB308]", "bg-[#22C55E]"];

  return (
    <div data-testid="password-strength" className="space-y-2.5">
      <div className="flex items-center gap-1.5">
        {[1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors duration-300 ${i <= score ? colors[score] : "bg-[#1A1A20]"}`}
          />
        ))}
        <span className="ml-2 w-16 text-right font-mono-code text-[10px] uppercase tracking-widest text-zinc-500">
          {labels[score]}
        </span>
      </div>
      <ul className="grid grid-cols-1 gap-1 sm:grid-cols-3">
        {rules.map((r) => (
          <li
            key={r.id}
            data-testid={`password-rule-${r.id}`}
            className={`flex items-center gap-1.5 text-[11px] transition-colors ${r.ok ? "text-emerald-400" : "text-zinc-600"}`}
          >
            {r.ok ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
            {r.label}
          </li>
        ))}
      </ul>
    </div>
  );
};
